import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';

export default function FeaturedMovies() {
  const featured = movies.slice(0, 8);

  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6 py-12 md:py-16">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
              <a href="#featured" id="featured">精选推荐</a>
            </h2>
            <p className="text-sm text-foreground-500 mt-1">热门电影 · 高清蓝光 · 好评如潮</p>
          </div>
          <Link
            to="/category/action"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {featured.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}